<template>
  <div id="app">
    <router-view />
    <!-- <img class="qr_code" ref="qrCode" /> -->
  </div>
</template>

<script>
// const promptpay = require('promptpay-qr');
import promptpay from "promptpay-qr";

export default {
  name: "app",
  mounted() {
    // 示例 PromptPay ID
    const promptpayId = "1234567890";
    // 金额
    const amount = 1000;
    // 生成 QR 码数据
    const qrCodeData = promptpay(promptpayId, { amount });
    console.log("qrCodeData", qrCodeData);

    // 生成二维码
    // QRCode.toDataURL(qrCodeData, {
    //   margin: 0, // 留白为空
    //   color: {
    //     dark: "#000",
    //     light: "#fff",
    //   },
    // })
    //   .then((url) => {
    //     this.$refs.qrCode.src = url;
    //   })
    //   .catch((err) => {
    //     console.error("QRCode.toDataURL", err);
    //   });
  },
};
</script>

<style lang="scss">
@import '@/themes/variables.scss';
@import '@/themes/shared.scss';
@import '@/themes/custom-blue/checkout.scss';

#app {
  // background: #F5F5F5;
}
.van-overlay {
  backdrop-filter: blur(30px);
  z-index: 3000;
}
.van-popup {
  background-color: transparent !important;
}

.qr_code {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 180px;
  height: 180px;
}

.computer_pay_container_step_account_submit,
.moblie_pay_container_step_account_submit,
.computer_pay_container_result_submit,
.moblie_pay_container_result_submit {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  column-gap: 8px;
}

.computer_pay_container_step_account_submit_text,
.moblie_pay_container_step_account_submit_text,
.computer_pay_container_result_submit_text,
.moblie_pay_container_result_submit_text {
  position: static !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px;
  line-height: 1.2;
  white-space: nowrap;
}

.computer_pay_container_step_account_submit_img,
.moblie_pay_container_step_account_submit_img,
.computer_pay_container_step_account_submit_text_img,
.moblie_pay_container_step_account_submit_text_img,
.computer_pay_container_result_submit_img,
.moblie_pay_container_result_submit_img {
  position: static !important;
  top: auto !important;
  right: auto !important;
  left: auto !important;
  transform: none !important;
  flex: 0 0 auto;
  margin: 0 !important;
  vertical-align: middle;
}

.computer_pay_container_step_account .computer_pay_container_step_account_input_box {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 15px;
  border: 1px solid #aaaaaa;
  margin-right: 20px;
  box-sizing: border-box;
}

.computer_pay_container_step_account .computer_pay_container_step_233 {
  flex: 0 0 100px;
  font-size: 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #dc811d;
  text-align: center;
}

.computer_pay_container_step_account .computer_pay_container_step_account_input {
  width: 100%;
  min-width: 0;
  margin-right: 10px;
  border: none;
  background: transparent;
  box-sizing: border-box;
  outline: none;
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #dc811d;
}

.computer_pay_container_step_account
  .computer_pay_container_step_account_input::placeholder {
  color: #bbbbbb;
}

.computer_pay_container_step_account
  .computer_pay_container_step_account_input_box:not(.computer_pay_container_step_account_input_box2)
  .computer_pay_container_step_account_input {
  height: 80px;
}

.moblie_pay_container_step_account .moblie_pay_container_step_account_input_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  border: 1px solid #aaaaaa;
  padding: 0 6px;
  box-sizing: border-box;
}

.moblie_pay_container_step_account .moblie_pay_container_step_233 {
  flex: 0 0 40px;
  color: #dc811d;
  font-size: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
}

.moblie_pay_container_step_account .moblie_pay_container_step_account_input {
  width: 100%;
  min-width: 0;
  border: none;
  background: transparent;
  box-sizing: border-box;
  outline: none;
  font-size: 11px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
}

.moblie_pay_container_step_account
  .moblie_pay_container_step_account_input::placeholder {
  color: #bbbbbb;
}

.moblie_pay_container_step_account
  .moblie_pay_container_step_account_input_box:not(.moblie_pay_container_step_account_input_box2)
  .moblie_pay_container_step_account_input {
  height: 40px;
}

.float-ball-text {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 50%;
  background: #1f2937;
  color: #ffffff;
  font-size: 16px;
  font-family: PingFangSC, PingFang SC, sans-serif;
  font-weight: 700;
  cursor: pointer;
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.72);
}
</style>
